import { Grid, makeStyles, MenuItem, TextField } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import UniDialog from "../../../Common/UniDialog";
import Signature from "./Signature";
import _ from 'lodash';
import FullscreenLoading from '../../../Common/FullscreenLoading';

const useStyles = makeStyles((theme) => ({
    signatureBackground: {
        width: '300px !important',
        height: '200px !important',
        borderRadius: 4,
        borderColor: '#636463',
        borderWidth: 2,
        borderStyle: 'dashed',
        backgroundColor: theme.palette.grey[900],
        display: 'inline-block', 
        position: 'relative'
    },
    signatureTitle: {
        fontSize: 14,
        fontWeight: 'normal',
        color: '#a3a4a0',
        marginBottom: 10
    }
}))

function DeliveryOperationDialog(props){
    const { open, onClose, onFinish } = props;
    const dispatch = useDispatch();
    const {t} = useTranslation('editOrder');
    const classes = useStyles();

    const [pods, setPods] = useState(['', '']);

    const handlePod = (index, file) => {
        let updatedPodArray = [...pods];
        updatedPodArray[index] = file;
        setPods(updatedPodArray);
    }

    useEffect(() => {
        if(open) {
            setPods(['', '']);
        }
    }, [open])

    return (
        <UniDialog
            title={t('dialog:upload_pod')}
            maxWidth='md'
            fullWidth
            open={open}
            onClose={()=>{
                onClose();
            }}
            autoClose={false}
            onFinish={()=>submit()}
            contentStyle={{overflow: 'hidden'}}
        >
            <Grid container spacing={8}>
                {
                    pods?.map((pod, index) => (
                        <Grid item xs={4}>
                            <div className={classes.signatureTitle}>
                                POD{index + 1}
                            </div>
                            <div className={classes.signatureBackground}>
                                <Signature 
                                    handlePodUpload={handlePod}
                                    index={index}
                                    pod={pod}
                                />
                                {
                                    pod &&
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 0,　
                                            right: 0,
                                            zIndex: 1000,
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => handlePod(index, '')}
                                        id="editorder-nexttransition-deliverypod-delete-img"
                                    >
                                        <img
                                            src='/images/icons/closeIcon.svg'
                                        />
                                    </div>
                                }
                            </div>
                        </Grid>
                    ))
                }
                <Grid item xs={4} className={classes.signatureTitle} style={{marginTop: 24}}>
                    <div>{t('image_introduction')}</div>
                    <div>{t('image_standard_1')}</div>
                    <div>{t('image_standard_2')}</div>
                    <div>{t('image_standard_3')}</div>
                </Grid>
            </Grid>
            <FullscreenLoading open={props.loading} />
        </UniDialog>
    )

    function submit(){
        onFinish(pods);
    }
}

export default DeliveryOperationDialog